import React, { useEffect, useState } from 'react';
import InputText from '../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { goToPage, doCallBack, stepParams, changeMobileHandler, validateMobileHandler, setDefaultCellular } from '../DisconnectServiceSlice'
import { Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';

function mobileGetterSection(props) {
    
    const valid = props.mobileForm.returnToNumberForm.valid;
    const IdNumber = props.UserInfo.IDNumber;
    const defaultMobile = props.UserInfo.contactNumber;
    const [mobileError, setMobileError] = useState(false)

    function reportAllGAOptionOnEnter() {
        if(props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_ENTERED_WE_SORRY_YOU_CHOOSE_TO_DISCONNECT.category, gaParams.DISCONNECT_ENTERED_WE_SORRY_YOU_CHOOSE_TO_DISCONNECT.eventType, gaParams.DISCONNECT_ENTERED_WE_SORRY_YOU_CHOOSE_TO_DISCONNECT.eventParams)
        }
        if(props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_ENTER_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.category, gaParams.DISCONNECT_ENTER_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.eventType, gaParams.DISCONNECT_ENTER_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.eventParams)
        }
        if(props.serviceToDisconnect.serviceType != "Cellular" && props.serviceToDisconnect.BusinessTypeCanBeDisconnected == true && props.serviceToDisconnect.canDisconnectOnline == true) {
            gaEvent(gaParams.DISCONNECT_ENTER_CALLBACK_PAGE.category, gaParams.DISCONNECT_ENTER_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.serviceToDisconnect.serviceType == "Cellular" && props.serviceToDisconnect.BusinessTypeCanBeDisconnected == true && props.serviceToDisconnect.canDisconnectOnline == true) {
            gaEvent(gaParams.DISCONNECT_ENTER_CALLBACK_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_CALLBACK_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_CALLBACK_PAGE_CELLULAR.eventParams)
        }
        if(props.finalDisconnectResponse === false && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_ENTER_UNSUCCESSFUL_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_UNSUCCESSFUL_DISCONNECT_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
    }

    function reportAllGAOptionOnClickFinish() {
        if(props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_CLICK_ON_FINISH_INSIDE_CALLBACK.category, gaParams.DISCONNECT_CLICK_ON_FINISH_INSIDE_CALLBACK.eventType, gaParams.DISCONNECT_CLICK_ON_FINISH_INSIDE_CALLBACK.eventParams)
        }
        if(props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_FINISH.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_FINISH.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_FINISH.eventParams)
        }
        if(props.deliverySet === false && props.finalDisconnectResponse === true) {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_AT_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.category, gaParams.DISCONNECT_CLICK_FINISH_AT_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.serviceToDisconnect.serviceType != "Cellular" && props.serviceToDisconnect.BusinessTypeCanBeDisconnected == true && props.serviceToDisconnect.canDisconnectOnline == true) {
            gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.serviceToDisconnect.serviceType == "Cellular" && props.serviceToDisconnect.BusinessTypeCanBeDisconnected == true && props.serviceToDisconnect.canDisconnectOnline == true) {
            gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_CONTINUE_CALLBACK_PAGE_CELLULAR.eventParams)
        }
    }

    async function redirect() {
        props.validateMobileHandler(props.mobileForm.returnToNumberForm);

        reportAllGAOptionOnClickFinish();

        if(valid) {
            const data = {
                id: IdNumber,
                mobile: props.mobileForm.returnToNumberForm.cellular,
                code: props.callBackCode
            }
            await props.doCallBack(data);

            if(props.deliverySet === false && props.finalDisconnectResponse === true) {
                props.goToPage({ page: 'FAILED_DELIVERY_PICK_UP', params: { ...stepParams, hideHeader: true } })
            }
            else {
                props.goToPage({ page: 'REPLAY_RESULT_PAGE', params: { ...stepParams, hideHeader: true } })
            }
        }
    }

    function goToSelfReturnCenter() {
        reportSelfCenterClick();
        props.goToPage({ page: 'SELF_PRODUCT_RETURN_PAGE', params: { ...stepParams, hideHeader: true } })
    }

    function reportSelfCenterClick() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_I_PREFER_TO_RETURN_EQUIPMENT_MYSELF_FAILED_DISCONNECT_IN_CALLBACK.category, gaParams.DISCONNECT_CLICK_ON_I_PREFER_TO_RETURN_EQUIPMENT_MYSELF_FAILED_DISCONNECT_IN_CALLBACK.eventType, props.serviceToDisconnect.serviceType);
    }

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        props.setDefaultCellular(defaultMobile);
        reportAllGAOptionOnEnter();
      }, [])

    useEffect(() => {
        if(props.mobileForm.returnToNumberForm.cellular != "") {
            props.validateMobileHandler(props.mobileForm.returnToNumberForm);
        }
    },[valid])

    useEffect(() => {
        if(props.mobileErrors.errors && props.mobileErrors.errors.cellular) {
            if(props.mobileErrors.errors.cellular !== "") {
                setMobileError(true)
            }
        }
        if(props.mobileErrors.errors.cellular === "" && props.mobileErrors.valid == "") {
            setMobileError(false)
        }
    },[props.mobileErrors.errors.cellular]);

    function reportGADeliveryFailed() {
        gaEvent(gaParams.DISCONNECT_ENTER_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.category, gaParams.DISCONNECT_ENTER_PAGE_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.eventType, props.serviceToDisconnect.serviceType)
    }

    function reportGAFailedUpgradeCellular() {
        gaEvent(gaParams.DISCONNECT_FAILED_TO_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.category, gaParams.DISCONNECT_FAILED_TO_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.eventType, gaParams.DISCONNECT_FAILED_TO_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.eventParams)
    }

    function renderHeaders() {
        
        if(props.serviceToDisconnect.canDisconnectOnline === false) {
            return (
            <>
                <h3 className="headers-big">אוקיי, מכבדים</h3>
                <h6 className="headers">כדי להשלים את הניתוק, יש צורך בנציג. נדאג לחזור אליך תוך יום עסקים</h6>
            </>)
        }
        else if(props.deliverySet === false && props.finalDisconnectResponse === true) {
            reportGADeliveryFailed();
            return (
                <>
                    <h3 className="headers-big">הצלחנו לבצע את הניתוק אך לא הצלחנו לתאם את שליחות</h3>
                    <h6 className="headers">באפשרותך להשאיר מספר טלפון ונציג יחזור אליך</h6>
                </>
            )
        }
        else if(props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            return (
            <>
                <h3 className="headers-big">רק שניה, אי אפשר להשלים את הניתוק כרגע</h3>
                <h6 className="headers">יש בקשה פתוחה למנוי או שהחבילה שלו לא מאפשרת ניתוק דיגיטלי. נדאג ליצור איתך קשר תוך יום עסקים אחד.</h6>
            </>)
        }
        else if(props.finalDisconnectResponse === false || props.getEquipmentFatalError === true) {
            return (
                <>
                    <h3 className="headers-big">אוקיי, זה לא היה צפוי! יש לנו תקלה בתהליך הניתוק</h3>
                    <h6 className="headers">נחזור אליך תוך יום עסקים אחד כדי להשלים את תהליך הניתוק</h6>
                </>)
        }
        else if(props.canUpgradeCellular === false) {
            reportGAFailedUpgradeCellular();
            return (
                <>
                    <h3 className="headers-big">מבאס ביותר</h3>
                    <h6 className="headers">התקנת התוכנית נכשלה, השאירו פרטים ונציגנו יחזור בהקדם להמשך השלמת התקנת התוכנית</h6>
                </>
            )
        }
        else
            return (
                <>
                    <h3 className="headers-big">מעולה, אנחנו פה לעזור</h3>
                    <h6 className="headers">נחזור אליך תוך יום עסקים אחד ונעשה את המקסימום כדי למצוא לך פתרון</h6>
                </>
            )
    }

    return (
        <Container className="mobile-getter-root">
            <Row className="headers-row">
                {renderHeaders()}
            </Row>
            <Row className="input-row">
                <span className="question-headers-big">לאיזה מספר להתקשר?</span>
                {/* <span className="question-headers-small">באפשרותך להזין מספר חלופי</span> */}
                <InputText value={props.mobileForm.returnToNumberForm.cellular} onChange={(e) => props.changeMobileHandler({target: e.target, form: props.mobileForm.returnToNumberForm})} id="txtInput" className="input-phone-txt" name="cellular" type="text" placeholder="נייד" required="required" error={props.mobileForm.returnToNumberForm.errors.cellular}/>
            </Row>
            <Row className="btn-row">
                    {mobileError === true ? <div className="errorMobile" style={{pointerEvents: 'none'}} ><BtnSubmit text="תחזרו אליי" onclick={() => redirect()}/></div> : <BtnSubmit text="תחזרו אליי" onclick={() => redirect()}/>}
            </Row>
            {props.deliverySet === false && props.finalDisconnectResponse === true ? <div className="selfReturn-line" onClick={() => goToSelfReturnCenter()}>רוצה להחזיר את הציוד בעצמי</div> : null}
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    mobileForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    UserInfo: state.authentication.loginData.userDetails,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    callbackOkResponse: state.disconnectServicesBlock.CallbackIsSuccess,
    deliverySet: state.disconnectServicesBlock.deliverySet,
    canUpgradeCellular: state.disconnectServicesBlock.canUpgradeCellular,
    getEquipmentFatalError: state.disconnectServicesBlock.getEquipmentFatalError,
    mobileErrors: state.disconnectServicesBlock.summarizeUserDisconnectDetails.returnToNumberForm
});
  
const mapDispatchToProps = {
    goToPage,
    changeMobileHandler,
    validateMobileHandler,
    doCallBack,
    setDefaultCellular
};
  
export default connect(mapStateToProps, mapDispatchToProps)(mobileGetterSection);